/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_4_DescInputs */

const en_pc_rv_4_desc = /** @type {(inputs: Pc_Rv_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It looks closer than it behaves. Some filters render differently from Adobe's, and memory can reach about 5 GB on large PSDs.`)
};

const zh_pc_rv_4_desc = /** @type {(inputs: Pc_Rv_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外观比行为更像。部分滤镜效果和 Adobe 不同，打开大型 PSD 时内存可能达到 5 GB 左右。`)
};

/**
* | output |
* | --- |
* | "It looks closer than it behaves. Some filters render differently from Adobe's, and memory can reach about 5 GB on large PSDs." |
*
* @param {Pc_Rv_4_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_4_desc = /** @type {((inputs?: Pc_Rv_4_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_4_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_4_desc(inputs)
	return zh_pc_rv_4_desc(inputs)
});
export { pc_rv_4_desc as "pc.rv.4.desc" }